module.exports = __webpack_public_path__ + "static/media/Slice2.c6261ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Slice2.png
// module id = 1605
// module chunks = 0